module.exports = __webpack_public_path__ + "static/media/1.cb88fb01.jpg";